import { render, staticRenderFns } from "./FinalAnswer.vue?vue&type=template&id=b1fdd264&"
import script from "./FinalAnswer.vue?vue&type=script&lang=js&"
export * from "./FinalAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports